import { render, staticRenderFns } from "./SentContactList.vue?vue&type=template&id=298ba4b8&scoped=true&"
import script from "./SentContactList.vue?vue&type=script&lang=js&"
export * from "./SentContactList.vue?vue&type=script&lang=js&"
import style0 from "./SentContactList.vue?vue&type=style&index=0&id=298ba4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ba4b8",
  null
  
)

export default component.exports